var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { CollapsibleContext } from './CollapsibleContext';
import { keys } from '../../utilities';
export const CollapsibleListItem = (_a) => {
    var { children, className, collapsible, el: Element = 'li' } = _a, rest = __rest(_a, ["children", "className", "collapsible", "el"]);
    const collapsibleItemRef = React.useRef(null);
    const collapsibleListRef = React.useRef(null);
    const [expanded, setExpanded] = React.useState((collapsible === null || collapsible === void 0 ? void 0 : collapsible.expanded) || false);
    const ListItemClasses = classnames('CollapsibleListItem', className, {
        'CollapsibleListItem--expanded': collapsible && expanded,
        'CollapsibleListItem--collapsed': collapsible && !expanded,
        'cursor-pointer': collapsible,
    });
    const handleClick = (e) => {
        var _a;
        if ((_a = collapsibleListRef === null || collapsibleListRef === void 0 ? void 0 : collapsibleListRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))
            return; // Prevent exapand/collapse on nested list items
        const { onClick } = rest;
        if (collapsible)
            setExpanded(!expanded);
        if (onClick)
            onClick(e);
    };
    const handleArrowKeypress = (e) => {
        var _a;
        if ((_a = collapsibleListRef === null || collapsibleListRef === void 0 ? void 0 : collapsibleListRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))
            return;
        if (collapsible) {
            e.preventDefault();
            if (e.key === keys.left && expanded)
                setExpanded(false);
            if (e.key === keys.right && !expanded)
                setExpanded(true);
        }
    };
    const handleKeyDown = (e) => {
        switch (e.key) {
            case keys.space:
            case keys.enter:
                handleClick(e);
                break;
            case keys.left: // Collapse
            case keys.right: // Expand
                handleArrowKeypress(e);
                break;
        }
    };
    // Appends CollapsibleList as a last element if CollapsibleItem
    const extract = (collapsible === null || collapsible === void 0 ? void 0 : collapsible.extractCollapsibleList) || false;
    React.useEffect(() => {
        if (extract && (collapsibleListRef === null || collapsibleListRef === void 0 ? void 0 : collapsibleListRef.current))
            collapsibleItemRef.current.append(collapsibleListRef.current);
    }, [extract]);
    const collapsibleContextValue = collapsible
        ? {
            animate: collapsible.animate || true,
            collapsibleRef: collapsibleListRef,
            expanded,
            extractCollapsibleList: collapsible.extractCollapsibleList || false,
        }
        : undefined;
    return (React.createElement(CollapsibleContext.Provider, { value: collapsibleContextValue },
        React.createElement(Element, Object.assign({ className: ListItemClasses, "data-anvil-component": "CollapsibleList", onClick: handleClick, onKeyDown: handleKeyDown, ref: collapsibleItemRef }, rest), children)));
};
//# sourceMappingURL=CollapsibleListItem.js.map